module.exports = __webpack_public_path__ + "img/read-complaint.aa0317d2.svg";